import { Node } from "@tiptap/core";

const CalculationDetailsNode = Node.create({
  name: "calculation-details",
  group: "inline",
  inline: true,
  // Remove atom: true if you want to allow content inside
  content: "inline*", // Allow inline content inside the node

  parseHTML() {
    return [
      {
        tag: "calculation-details",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["calculation-details", HTMLAttributes, 0]; // The 0 tells TipTap where to insert content
  },

  addNodeView() {
    return ({ node, HTMLAttributes }) => {
      const span = document.createElement("span");
      span.classList.add("calculation-details");
      span.style.backgroundColor = "#ccc";

      const content = document.createElement("span");
      span.appendChild(content);

      return {
        dom: span,
        contentDOM: content,
      };
    };
  },
});

export default CalculationDetailsNode;
